var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "panel panel-default" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title" }, [
        _vm._v("1. Save Your Media (up to 10) " + _vm._s(_vm.test)),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "panel-body" }, [
      _vm.medias.length > 1
        ? _c("div", [
            _c("p", [
              _vm._v(
                "Press and hold on each image or video you would like to include in your Instagram post and save it to your library using the pop-up menu."
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showSafariDownloadInstructions,
                    expression: "showSafariDownloadInstructions",
                  },
                ],
                staticClass: "alert alert-dismissible",
                attrs: { role: "alert" },
              },
              [_vm._m(0), _vm._v(" "), _vm._m(1)]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gallery" },
              [
                _vm._l(_vm.medias, function (media, index) {
                  return [
                    media.mediatype === _vm.$mediaType.Image &&
                    index < _vm.showCount
                      ? _c("gallery-image", {
                          key: index,
                          attrs: { photo: media },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    media.mediatype === _vm.$mediaType.Video &&
                    index < _vm.showCount
                      ? _c("gallery-video", {
                          key: index,
                          attrs: { video: media },
                        })
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.medias.length > 1 && _vm.showCount < _vm.medias.length
        ? _c(
            "button",
            {
              staticClass: "btn btn-success btn-lg btn-block",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.showMoreClick()
                },
              },
            },
            [_vm._v("Show More")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.medias.length == 1
        ? _c(
            "div",
            { staticClass: "post" },
            [
              _c("p", [
                _vm._v(
                  "Press and hold on the image or video and save it to your library using the pop-up menu."
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSafariDownloadInstructions,
                      expression: "showSafariDownloadInstructions",
                    },
                  ],
                  staticClass: "alert alert-dismissible",
                  attrs: { role: "alert" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Close",
                        title: "Don't Show Again",
                      },
                      on: { click: _vm.dontShowAgainClick },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(2),
                ]
              ),
              _vm._v(" "),
              _vm.medias[0].mediatype === _vm.$mediaType.Image
                ? _c("gallery-image", { attrs: { photo: _vm.medias[0] } })
                : _vm._e(),
              _vm._v(" "),
              _vm.medias[0].mediatype === _vm.$mediaType.Video
                ? _c("gallery-video", { attrs: { video: _vm.medias[0] } })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "modalVideo",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "myModalLabel",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.dontShowAgainClick },
                  },
                  [_vm._v("Don't Show Again")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button", "data-dismiss": "modal" },
                  },
                  [_vm._v("Close")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "alert",
          "aria-label": "Close",
          title: "Don't Show Again",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "span",
      {
        staticClass: "launchmodal",
        attrs: { "data-toggle": "modal", "data-target": "#modalVideo" },
      },
      [
        _c("i", { staticClass: "glyphicon glyphicon-info-sign" }),
        _vm._v("How to save video in Safari"),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "span",
      {
        staticClass: "launchmodal",
        attrs: { "data-toggle": "modal", "data-target": "#modalVideo" },
      },
      [
        _c("i", { staticClass: "glyphicon glyphicon-info-sign" }),
        _vm._v("How to save video in Safari"),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title", attrs: { id: "myModalLabel" } }, [
        _vm._v("Downloading Video"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v(
          'Safari downloads videos to the "Files" app, which is unrecognized by Instagram. Follow these steps to enable Instagram to see your videos:'
        ),
      ]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [_vm._v("Long press on a video")]),
        _vm._v(" "),
        _c("li", [_vm._v('Select "Download Linked File"')]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Tap the Safari Download Manager icon (top right) "),
          _c("img", {
            staticClass: "ios-icon",
            attrs: { src: require("../../images/ios_download.png"), alt: "" },
          }),
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Tap the downloaded video in the list")]),
        _vm._v(" "),
        _c("li", [
          _vm._v('Press the "Share" icon (bottom left) '),
          _c("img", {
            staticClass: "ios-icon",
            attrs: { src: require("../../images/ios_export.png"), alt: "" },
          }),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v('Tap "Save Video" to copy the video to your Photos album'),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }